module.exports = __webpack_public_path__ + "img/ta-hj-leftTitle01.3b27610e.png";